import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/city-clerk/$id/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/city-clerk/$id/"!</div>
}
